(() => {
  if (window.__wwAutumn) return;
  window.__wwAutumn = true;
  const root = window.Shopify?.routes?.root || '/';
  const $ = (s, p = document) => p.querySelector(s);
  const $$ = (s, p = document) => [...p.querySelectorAll(s)];
  const dialog = () => $('#WWCart');
  const format = (cents, currency = 'EUR', locale = 'de-AT') => new Intl.NumberFormat(locale, {style:'currency',currency}).format(cents / 100);
  let lastTrigger;
  let changing = false;
  async function json(url, options) {
    const response = await fetch(url, options);
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Bitte versuche es erneut.');
    return data;
  }
  const post = (path, body) => json(root + path, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});
  const cartError = (message) => $$('[data-ww-cart-error]').forEach(el => {el.textContent=message;el.hidden=!message;});
  async function refreshCart(cart) {
    cart = cart || await json(root + 'cart.js');
    $$('[data-ww-cart-count]').forEach(el => {el.textContent=cart.item_count;});
    const surfaces = $$('[data-ww-cart-surface]');
    const ids = [...new Set(surfaces.map(el => el.dataset.sectionId).filter(Boolean))];
    if (ids.length) {
      const url = new URL(location.href);
      url.searchParams.set('sections',ids.join(','));
      const rendered = await json(url.toString());
      surfaces.forEach(surface => {
        const markup = rendered[surface.dataset.sectionId];
        if (!markup) return;
        const doc = new DOMParser().parseFromString(markup,'text/html');
        const fresh = $('[data-ww-cart-fragment]',doc);
        const current = $('[data-ww-cart-fragment]',surface);
        if (fresh && current) current.replaceWith(fresh);
      });
    }
    document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:'ww-autumn',data:{itemCount:cart.item_count,source:'ww-autumn'}}}));
    return cart;
  }
  function openCart(trigger, refresh = true) {
    const d = dialog();
    if (!d) {location.href=root+'cart';return;}
    lastTrigger=trigger || document.activeElement;
    if (!d.open) d.showModal();
    document.documentElement.style.overflow='hidden';
    $('[data-ww-close-cart]',d)?.focus();
    if (refresh) refreshCart().catch(err => cartError(err.message));
  }
  function closeCart() {dialog()?.close();}
  function bindDialog() {
    const d=dialog();if(!d || d.dataset.bound) return;d.dataset.bound='true';
    d.addEventListener('close',()=>{document.documentElement.style.overflow='';lastTrigger?.focus?.();});
    d.addEventListener('click',event=>{if(event.target!==d)return;const rect=d.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)closeCart();});
  }
  function bindOffer(offer) {
    if(offer.dataset.bound)return;offer.dataset.bound='true';
    const data=JSON.parse($('[data-ww-offer-data]',offer).textContent);
    const form=$('[data-ww-offer-form]',offer);
    const add=$('[type=submit]',form);
    const variant=$('[name=id]',form);
    const radios=$$('[name=quantity]',form);
    const sticky=$('[data-ww-mobile-buy]',offer);
    const stickyButton=$('[data-ww-sticky-add]',offer);
    const error=$('[data-ww-offer-error]',offer);
    const current=()=>data.variants.find(v=>String(v.id)===variant?.value);
    const quantity=()=>Number($('[name=quantity]:checked',form)?.value||1);
    const money=c=>format(c,data.currency||'EUR',data.locale||'de-AT');
    const update=()=>{
      const selected=current();const price=selected?.price??data.price;
      $$('[data-ww-tier-price]',offer).forEach(el=>{el.textContent=money(price*Number(el.dataset.wwTierPrice));});
      $$('[data-ww-offer-total],[data-ww-sticky-total]',offer).forEach(el=>{el.textContent=money(price*quantity());});
      const unavailable=data.preview||!selected?.available;
      add.disabled=unavailable;if(stickyButton)stickyButton.disabled=unavailable;
    };
    radios.forEach(el=>el.addEventListener('change',update));variant?.addEventListener('change',update);
    form.addEventListener('submit',async event=>{
      event.preventDefault();event.stopImmediatePropagation();
      if(add.disabled||data.preview)return;
      error.hidden=true;add.disabled=true;add.setAttribute('aria-busy','true');
      try{
        await post('cart/add.js',{items:[{id:Number(variant.value),quantity:quantity()}]});
        await refreshCart();openCart(add, false);
      }catch(err){error.textContent=err.message;error.hidden=false;}
      finally{add.removeAttribute('aria-busy');update();}
    });
    stickyButton?.addEventListener('click',()=>{if(!add.disabled)form.requestSubmit(add);});
    if(sticky && 'IntersectionObserver' in window){
      const observer=new IntersectionObserver(entries=>{const e=entries[0];sticky.hidden=e.isIntersecting||e.boundingClientRect.top>=0;},{threshold:0});observer.observe(add);
      const footerObserver=new IntersectionObserver(entries=>{if(entries[0].isIntersecting)sticky.hidden=true;});const footer=$('footer');if(footer)footerObserver.observe(footer);
    }
    const gallery=$('[data-ww-gallery]',offer), thumbs=$$('[data-ww-thumb]',offer);
    const updateThumb=()=>{const index=Math.round(gallery.scrollLeft/gallery.clientWidth);thumbs.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));};
    thumbs.forEach(button=>button.addEventListener('click',()=>{gallery.scrollTo({left:Number(button.dataset.wwThumb)*gallery.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}));
    gallery?.addEventListener('scroll',updateThumb,{passive:true});
    gallery?.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight'].includes(e.key))return;e.preventDefault();gallery.scrollBy({left:(e.key==='ArrowRight'?1:-1)*gallery.clientWidth,behavior:'smooth'});});
    update();
  }
  const revealObserver='IntersectionObserver' in window?new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('ww-reveal-seen');revealObserver.unobserve(entry.target);}}),{threshold:.08}):null;
  function boot(scope=document){
    $$('[data-ww-offer]',scope).forEach(bindOffer);bindDialog();
    if(!matchMedia('(prefers-reduced-motion: reduce)').matches)$$('[data-ww-reveal]',scope).forEach(el=>{if(el.dataset.observed)return;el.dataset.observed='true';if(revealObserver){el.classList.add('ww-reveal-ready');revealObserver.observe(el);}});
    $$('video',scope).forEach(video=>{if(video.dataset.bound)return;video.dataset.bound='true';video.addEventListener('play',()=>$$('video').forEach(other=>{if(other!==video)other.pause();}));});
  }
  document.addEventListener('click',async event=>{
    const open=event.target.closest('[data-ww-open-cart]');if(open){event.preventDefault();openCart(open);return;}
    const close=event.target.closest('[data-ww-close-cart]');if(close){closeCart();return;}
    const change=event.target.closest('[data-ww-cart-change]');if(!change||changing)return;
    changing=true;cartError('');$$('[data-ww-cart-surface]').forEach(el=>el.setAttribute('aria-busy','true'));
    try{const cart=await post('cart/change.js',{id:change.dataset.wwCartChange,quantity:Number(change.dataset.quantity)});await refreshCart(cart);}
    catch(err){cartError(err.message);}
    finally{changing=false;$$('[data-ww-cart-surface]').forEach(el=>el.removeAttribute('aria-busy'));}
  });
  document.addEventListener('shopify:section:load',event=>boot(event.target));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot());else boot();
})();
